import CustomTextField from './TextInputStyle'
import PropTypes from 'prop-types'
import React from 'react'
import { LabelInput } from '../../Main'
import { numberFormat } from '../../../utility/Helpers'

const TextInput = (props) => {
  const {
    labelInput,
    onChange,
    required = false,
    sx = {},
    className = {},
    readOnly = false,
    InputProps = {},
    labelStyle = { color: '#444', fontWeight: '700', fontSize: '0.875rem' },
    ...otherProps
  } = props
  return (
    <>
      {labelInput && (
        <LabelInput sx={{ ...labelStyle }}>
          {labelInput}
          {required && <span style={{ color: 'red' }}>*</span>}
        </LabelInput>
      )}
      <CustomTextField
        {...otherProps}
        onChange={(e) => {
          if (props.inputtype === 'number') {
            e.target.value = numberFormat(e.target.value)
          }
          onChange(e)
        }}
        InputProps={{
          ...InputProps,
          readOnly: readOnly,
        }}
        sx={{ ...sx }}
        className={className}
        style={{ backgroundColor: 'white' }}
      />
    </>
  )
}

TextInput.propTypes = {
  className: PropTypes.any,
  inputtype: PropTypes.string,
  InputProps: PropTypes.any,
  labelInput: PropTypes.string,
  labelStyle: PropTypes.any,
  onChange: PropTypes.func,
  oneKeyDown: PropTypes.string,
  props: PropTypes.any,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  sx: PropTypes.object,
}

export default TextInput
